module.exports = __webpack_public_path__ + "img/certified.153b67e.webp";